import PropTypes from 'prop-types';

const isArrayOfTwoOrLess = (props, propName, componentName) =>
  !props?.secondary ||
  (props?.secondary?.length < 3
    ? true
    : new Error(
        `<${componentName} ${propName} needs to be an array of two or less`
      ));

export const secondaryAttributesShape = (props, propName, componentName) =>
  !props?.secondary ||
  (isArrayOfTwoOrLess(props, propName, componentName) &&
    props?.secondary?.every(
      secondary =>
        typeof secondary === 'string' || typeof secondary?.value === 'string'
    ))
    ? null
    : new Error(
        `<${componentName} ${propName} must either be a string or an object containing 'value' (required) and 'searchable' (optional) properties`
      );

/** 'optionShape' defines propType shape of a single 'option'. */
export const optionShape = {
  /** Each 'value' must be unique: Options with duplicate values will be removed! 'value' is the only property searched with the default filter.
   */
  value: PropTypes.string.isRequired,
  /** 'label' value is rendered when 'option' is selected, and also in the menu. If no 'label' is provided, the 'value' will be copied to 'label'. A render-props component can also be provided for custom rendering, 'theme' will be passed back as an argument.
   */
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.element
  ]),
  /** 'secondary' is used to define an array of up to 2 strings that are displayed in a bullet-separated list below the label
   */
  secondary: secondaryAttributesShape,
  /** Text for tooltip */
  tooltipText: PropTypes.string,
  /** If heading evaluates to true, option will be styled as a heading, and will not be interactive */
  heading: PropTypes.bool,
  /** Display disabled styling for 'option', remove interactivity (cannot be selected). */
  disabled: PropTypes.bool,
  /** Adds styling to options that actuate destructive actions */
  destructive: PropTypes.bool,
  /** adds line break at top of option */
  lineBreak: PropTypes.bool,
  /** Optional property for storing additional data (usually used upon selection). */
  payload: PropTypes.any
};
